import { People, Person, UserIconFilled } from '@/components/icons'
import { MatchByPlayType } from '@/components/match/MatchByPlayType'
import { EventFormat, Match, PlayerOfTeam } from '@/types'
import { HistoryMatch } from '.'

export type HistoryMatchesProps = {
  matches: Match[]
  playerId: number
  singleRating: number | undefined
  doubleRating: number | undefined
}

export const HistoryMatches = ({ matches, playerId, singleRating, doubleRating }: HistoryMatchesProps) => {
  let lastPreMatchRatingSingle: number
  let lastPreMatchRatingDouble: number
  let lastPreMatchRating: number

  const renderMatchTitle = (eventFormat: EventFormat, teamMate: PlayerOfTeam | undefined = undefined) => {
    return (
      <div className="flex flex-row items-center py-2 px-4 bg-navy-900 bg-opacity-[2%] gap-x-2 w-full truncate">
        <div className="rounded-full bg-navy-900 bg-opacity-10">
          <div className="w-[28px] h-[28px] relative">
            <div className="absolute w-full h-full flex justify-center items-center">
              {eventFormat === 'SINGLES' ? <Person /> : <People />}
            </div>
          </div>
        </div>
        {eventFormat === 'SINGLES' ? (
          <p className="text-sm flex flex-row items-center gap-x-2 text-navy-900 truncate">Singles</p>
        ) : (
          <div className="text-sm flex flex-row items-center gap-x-2 text-navy-900 truncate">
            Doubles <span className="text-opacity-50 text-navyBlue">With</span>
            <span>
              <div className="rounded-full">
                <div className="w-4 h-4 relative">
                  <div className="absolute w-full h-full">
                    {teamMate?.imageUrl ? (
                      <img src={teamMate.imageUrl} alt="" className="w-4 h-4 rounded-full" />
                    ) : (
                      <UserIconFilled className="w-4 h-4" />
                    )}
                  </div>
                </div>
              </div>
            </span>
            <span className="truncate">{teamMate?.fullName}</span>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      {matches.map((match, i) => (
        <div className="mt-3" key={`${match.id}-${i}`}>
          <MatchByPlayType
            matchPlayType={match.matchPlayType}
            matchDate={match.eventDate}
            adjustmentData={{ eventName: match.eventName, match }}
            regular={() => {
              const opponentTeam =
                match.eventFormat === 'SINGLES'
                  ? match.teams.find((team) => team.player1.id !== playerId)
                  : match.teams.find((team) => team.player1.id !== playerId && team.player2.id !== playerId)

              const playerTeam = match.teams.find((team) => team != opponentTeam)

              const playerNumber = playerTeam?.player1.id === playerId ? 1 : 2

              const preMatchRating =
                playerNumber === 1
                  ? match.eventFormat === 'SINGLES'
                    ? playerTeam?.preMatchRatingAndImpact.preMatchSingleRatingPlayer1
                    : playerTeam?.preMatchRatingAndImpact.preMatchDoubleRatingPlayer1
                  : match.eventFormat === 'SINGLES'
                    ? playerTeam?.preMatchRatingAndImpact.preMatchSingleRatingPlayer2
                    : playerTeam?.preMatchRatingAndImpact.preMatchDoubleRatingPlayer2

              const matchImpact =
                playerNumber === 1
                  ? match.eventFormat === 'SINGLES'
                    ? playerTeam?.preMatchRatingAndImpact.matchSingleRatingImpactPlayer1
                    : playerTeam?.preMatchRatingAndImpact.matchDoubleRatingImpactPlayer1
                  : match.eventFormat === 'SINGLES'
                    ? playerTeam?.preMatchRatingAndImpact.matchSingleRatingImpactPlayer2
                    : playerTeam?.preMatchRatingAndImpact.matchDoubleRatingImpactPlayer2

              if (match.eventFormat === 'SINGLES') {
                lastPreMatchRating = lastPreMatchRatingSingle
                if (preMatchRating && preMatchRating !== lastPreMatchRatingSingle) {
                  lastPreMatchRatingSingle = preMatchRating
                }
              } else {
                lastPreMatchRating = lastPreMatchRatingDouble
                if (preMatchRating && preMatchRating !== lastPreMatchRatingDouble) {
                  lastPreMatchRatingDouble = preMatchRating
                }
              }

              if (!lastPreMatchRatingDouble && doubleRating) {
                lastPreMatchRatingDouble = Number(doubleRating)
                lastPreMatchRating = lastPreMatchRatingDouble
              }
              if (!lastPreMatchRatingSingle && singleRating) {
                lastPreMatchRatingSingle = Number(singleRating)
                lastPreMatchRating = lastPreMatchRatingSingle
              }

              const teamMate = playerTeam?.player1.id !== playerId ? playerTeam?.player1 : playerTeam?.player2

              const lastPlayerTeam = matches[i - 1]?.teams.find(
                (team) => team?.player1?.id === playerId || team?.player2?.id === playerId
              )

              const lastTeamMate =
                lastPlayerTeam?.player1.id === playerId ? lastPlayerTeam?.player2 : playerTeam?.player1

              return (
                <>
                  {match?.eventFormat === matches[i - 1]?.eventFormat &&
                    teamMate?.id !== lastTeamMate?.id &&
                    renderMatchTitle(match.eventFormat, teamMate)}
                  {match?.eventFormat !== matches[i - 1]?.eventFormat && (
                    <>
                      {match.eventFormat === 'SINGLES'
                        ? renderMatchTitle(match.eventFormat)
                        : renderMatchTitle(match.eventFormat, teamMate)}
                    </>
                  )}
                  <HistoryMatch
                    match={match}
                    index={i}
                    playerId={playerId}
                    preMatchRating={
                      preMatchRating ? preMatchRating : lastPreMatchRating ? lastPreMatchRating : undefined
                    }
                    ratingImpact={matchImpact ? matchImpact : 0}
                    opponentTeam={opponentTeam}
                    playerTeam={playerTeam}
                  />
                </>
              )
            }}
          />
        </div>
      ))}
    </>
  )
}

export default HistoryMatches
